import { cn } from '@mntn-dev/ui-utilities'

import type { SkeletonBaseProps } from './types.ts'

const SkeletonBase = ({
  children,
  className,
  style,
  variant = 'rounded',
}: SkeletonBaseProps) => {
  return (
    <div
      className={cn(
        'skeleton-line w-full',
        variant === 'rounded' && 'rounded-lg',
        className
      )}
      style={style}
    >
      {children}
    </div>
  )
}

export { SkeletonBase, type SkeletonBaseProps }
